var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.21 493.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#cae19d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,417.23s53-266.8-127-316.8-529.71-143-466.35,326l58.35,67S220.93-156,600.93,417.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M600.93,417.23,569.23,477S548.66,336.93,511.3,299.18l67.43-21.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.49,75.46S374.7,5,449.62,0c0,0,12,82.54-74.17,99S371.49,75.46,371.49,75.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M410.88,206.43s121.4,127.75,114.4,180.75c0,0,31.85-26.39,25.42-80.19s-81.23-100.56-81.23-100.56Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset28);
export default __webpack_public_path__ + "static/media/Asset 28.81f5669d.svg";
export { ForwardRef as ReactComponent };